<template>
  <v-container>
    <v-row no-gutters>
      <v-col cols="12">
        <notification-container
          v-if="!unnotification"
          :showOnlyLocalNotifications="true"
        ></notification-container>
      </v-col>
    </v-row>
    <v-row>
      <v-col xs="12" md="4">
        <v-text-field
          id="signer_form_document__nombres__text"
          v-model="signer.nombres"
          :counter="80"
          :error-messages="getErrors('signer.nombres', 'Los nombres')"
          label="Nombres"
          required
          @input="$v.signer.nombres.$touch()"
        ></v-text-field>
      </v-col>
      <v-col xs="12" md="4">
        <v-text-field
          id="signer_form_document__apellido_paterno__text"
          v-model="signer.paterno"
          :counter="50"
          :error-messages="getErrors('signer.paterno', 'El apellido paterno')"
          label="Apellido Paterno"
          required
          @input="$v.signer.paterno.$touch()"
        ></v-text-field>
      </v-col>
      <v-col xs="12" md="4">
        <v-text-field
          id="signer_form_document__apellido_materno__text"
          v-model="signer.materno"
          :counter="50"
          :error-messages="getErrors('signer.materno', 'El apellido materno')"
          label="Apellido Materno"
          @input="$v.signer.materno.$touch()"
        ></v-text-field>
      </v-col>
    </v-row>
    <v-row>
      <v-col xs="12" md="8">
        <v-text-field
          id="signer_form_document__email__text"
          v-model="signer.email"
          :counter="120"
          :error-messages="getErrors('signer.email', 'El Email')"
          label="Email"
          required
          @input="$v.signer.email.$touch()"
        ></v-text-field>
      </v-col>
      <v-col xs="12" md="4">
        <v-text-field
          id="signer_form_document__rfc__text"
          v-model="signer.rfc"
          :counter="13"
          :error-messages="getErrors('signer.rfc', 'El RFC')"
          label="RFC"
          required
          @input="$v.signer.rfc.$touch()"
        ></v-text-field>
      </v-col>
    </v-row>

    <v-row justify="end" class="pt-6">
      <v-btn id="signer_form_document__cancelar__button" text color="error" :disabled="loading" @click="hideForm"
        >Cancelar</v-btn
      >
      <v-btn
        id="signer_form_document__guardar__button"
        class="ml-2"
        color="success"
        :disabled="this.$v.$invalid"
        :loading="loading"
        @click="submit"
        >Guardar</v-btn
      >
    </v-row>
  </v-container>
</template>

<script>
import { pushNotification, messageErrorResponse, userData } from '@/store/helpers'
import VuelidateHelper from '@/utils/VuelidateHelper'
import { maxLength, required } from 'vuelidate/lib/validators'
import { notSpecialChars, rfcValidation, rfcDuplicate, rfcNotOwner, capitalize, emailValidation, emailDuplicate, emailNotOwner } from '@/utils/VuelidateCustoms'
import Signer from '@/models/Signer'
import {
  signersStoreData,
  signersStoreActions
} from '@/modules/signers/store/signersStoreHelpers'

export default {
  name: 'SignerFormDocument',
  props: {
    value: {
      type: Signer
    },
    documentId: {
      type: String
    },
    type: {
      type: String
    },
    signersList: {
      type: Array
    }
  },
  data() {
    return {
      vuelidateHelper: null,
      loading: false,
      unnotification: { type: Boolean, default: false },
      signer: { type: Signer }
    }
  },
  created() {
    this.signer = Object.assign(new Signer(), this.value)
    this.vuelidateHelper = new VuelidateHelper(this.$v)
  },
  computed: {
    ...signersStoreData,
    ...userData
  },
  watch: {
    'signer.nombres': function(text) {
      this.signer.nombres = capitalize(text, true)
    },
    'signer.paterno': function(text) {
      this.signer.paterno = capitalize(text, true)
    },
    'signer.materno': function(text) {
      this.signer.materno = capitalize(text, true)
    },
    'signer.rfc': function(text) {
      this.signer.rfc = text.toUpperCase()
    }
  },
  methods: {
    ...signersStoreActions,
    getErrors(campo, label = '') {
      return this.vuelidateHelper.getErrors(campo, label)
    },
    hideForm() {
      this.$emit('cancel')
    },
    submit() {
      this.$v.$touch()
      if (this.$v.$anyError) {
        return
      }
      this.loading = true

      let data = {
        nombres: this.signer.nombres,
        paterno: this.signer.paterno,
        materno: this.signer.materno,
        rfc: this.signer.rfc,
        email: this.signer.email
      }

      let transaction
      let event
      if (this.type == 'add') {
        data.idDocumento = this.documentId
        data.orden = this.signer.orden
        data.firmarEnOrden = this.signer.firmarEnOrden
        event = 'created'
        transaction = this.addSignerToDocument(data)
      } else {
        data.id = this.signer.id
        event = 'updated'
        transaction = this.updateSignerToDocument(data)
      } 

      transaction
        .then(result => {   
          this.$emit(event, event == 'created' ? result[0] : result)
        })
        .catch(err => {
          this.notificationError(err)
        })
        .finally(() => {
          if(event == 'updated') {
            this.notifySignerById(this.signer.id)
          }
          
          this.loading = false
        })
    },
    notificationError(msg) {
      pushNotification(
        this.$store,
        messageErrorResponse(msg) || this.msgSignerServiceError,
        'error',
        'left',
        false,
        true
      )
    }
  },
  validations() {
    return {
      signer: {
        nombres: { required, maxLength: maxLength(80), notSpecialChars },
        paterno: { required, maxLength: maxLength(50), notSpecialChars },
        materno: { maxLength: maxLength(50), notSpecialChars },
        email: { required, maxLength: maxLength(120), emailValidation, emailDuplicate: emailDuplicate({id: this.signer.id, signers: this.signersList}), emailNotOwner: emailNotOwner({signer: this.value, owner: this.accountData}) },
        rfc: { required, maxLength: maxLength(13), rfcValidation, rfcDuplicate: rfcDuplicate({id: this.signer.id, signers: this.signersList}), rfcNotOwner: rfcNotOwner({signer: this.value, owner: this.accountData}) }
      }
    }
  }
}
</script>
